/** @format */

import { Modal, Space } from "antd";
import { ColumnsType } from "antd/lib/table";
import {
  ButtonTableApproval,
  ButtonTableDelete,
  ButtonTableDetail,
} from "components/Button";
import moment from "moment";
// import "moment/locale/id";
import { formatCurr, getBatch } from "utils/helper";

const listBatch = getBatch();

/**
 * Baris pengajuan/penyaluran data lama tanpa jenjang dikirim BE sebagai "-".
 * Aksi Salurkan/Batalkan untuk baris tsb diblokir: "-" ditolak BE, sedangkan
 * jenjang kosong membuat BE memproses SEMUA jenjang di batch/tahap itu.
 */
export const isJenjangValid = (jenjang: any): boolean =>
  !!jenjang && jenjang !== "-";

export const JENJANG_INVALID_MESSAGE =
  "Aksi tidak dapat diproses untuk data tanpa jenjang";

const columnJenjang = {
  title: "Jenjang",
  key: "jenjang",
  width: 100,
  dataIndex: "jenjang",
  render: (jenjang: any) => jenjang || "-",
};

export const columnsDokumen = (
  provinsi: any,
  kabkota: any,
  handleDelete: (values: any, action: string) => void,
) => [
  {
    title: "NSM",
    key: "nsm",
    dataIndex: "nsm",
  },
  {
    title: "Madrasah",
    dataIndex: "nama_madrasah",
    key: "nama_madrasah",
    width: 200,
  },
  {
    title: "Jenjang",
    dataIndex: "jenjang",
    key: "jenjang",
    render: (jenjang) => <div className="uppercase">{jenjang}</div>,
  },
  {
    title: "Provinsi",
    dataIndex: "kode_provinsi",
    key: "kode_provinsi",
    width: 200,
    render: (kode_provinsi) => {
      return provinsi.find((item) => item.kode === kode_provinsi)?.nama || "";
    },
  },
  {
    title: "Kabkota",
    dataIndex: "kode_kabkota",
    key: "kode_kabkota",
    width: 200,
    render: (kode_kabkota) => {
      return kabkota.find((item) => item.kode === kode_kabkota)?.nama || "";
    },
  },
  {
    title: "Alokasi Anggaran",
    key: "Nominal",
    children: [
      {
        title: "Tahap 1",
        dataIndex: "tahap1",
        key: "tahap1",
        render: (tahap1) => (
          <div className="text-right">{formatCurr(tahap1)}</div>
        ),
      },
      {
        title: "Tahap 2",
        key: "tahap2",
        dataIndex: "tahap2",
        render: (tahap2) => (
          <div className="text-right">{formatCurr(tahap2)}</div>
        ),
      },
      {
        title: "Triwulan 1",
        key: "triwulan1",
        dataIndex: "triwulan1",
        render: (triwulan1) => (
          <div className="text-right">{formatCurr(triwulan1)}</div>
        ),
      },
      {
        title: "Triwulan 2",
        key: "triwulan2",
        dataIndex: "triwulan2",
        render: (triwulan2) => (
          <div className="text-right">{formatCurr(triwulan2)}</div>
        ),
      },
      {
        title: "Triwulan 3",
        key: "triwulan3",
        dataIndex: "triwulan3",
        render: (triwulan3) => (
          <div className="text-right">{formatCurr(triwulan3)}</div>
        ),
      },
      {
        title: "Triwulan 4",
        key: "triwulan4",
        dataIndex: "triwulan4",
        render: (triwulan4) => (
          <div className="text-right">{formatCurr(triwulan4)}</div>
        ),
      },
      {
        title: "Nominal Non AA",
        key: "nominalNonAA",
        render: (record) => (
          <div className="text-right">
            {formatCurr(record.tahap2 - record.nilai_aa)}
          </div>
        ),
      },
      {
        title: "Nominal AA",
        key: "nilai_aa",
        dataIndex: "nilai_aa",
        render: (nilai_aa) => (
          <div className="text-right">{formatCurr(nilai_aa)}</div>
        ),
      },
      {
        title: "Total",
        key: "nominal_alokasi",
        // dataIndex: "total",
        render: (record) => {
          let total =
            record?.tahap1 +
            record?.tahap2 +
            record?.triwulan1 +
            record?.triwulan2 +
            record?.triwulan3 +
            record?.triwulan4;
          return <div className="text-right">{formatCurr(total)}</div>;
        },
      },
    ],
  },
  {
    title: "Tahapan",
    key: "tahapan",
    dataIndex: "tahapan",
    render: (tahapan) => `Tahap ${tahapan}`,
  },
  {
    title: "Tanggal Verifikasi",
    key: "tanggal_verifikasi",
    width: 300,
    dataIndex: "tanggal_verifikasi",
    render: (tanggal_verifikasi) =>
      moment(tanggal_verifikasi).format("dddd,DD MMM YYYY HH:mm:ss"),
  },
  {
    title: "Rekening Madrasah",
    key: "rekening",
    children: [
      {
        title: "Nama BANK",
        dataIndex: "nama_bank",
        key: "nama_bank",
      },
      {
        title: "No Rekening",
        key: "nomor_rekening",
        dataIndex: "nomor_rekening",
      },
      {
        title: "Nama Pemilik",
        key: "nama_pemilik_rekening",
        dataIndex: "nama_pemilik_rekening",
      },

      {
        title: "Cabang",
        key: "cabang",
        dataIndex: "cabang",
      },
    ],
  },

  {
    title: "Aksi",
    key: "aksi",
    width: "100%",
    fixed: "right",
    render: (record) => {
      return (
        <Space>
          <ButtonTableDelete
            onClick={() => {
              Modal.confirm({
                title: "Perhatian",
                content: "Yakin Hapus Data?",
                centered: true,
                wrapClassName: "erkam-custom-modal",
                onOk() {
                  return handleDelete(record, "verifikasi");
                },
                okText: "Hapus",
                cancelText: "Batal",
                okType: "danger",
              });
            }}
          />
        </Space>
      );
    },
  },
];

export const columnsPengajuan = (
  route: any,
  dataState: any,
  handlePencairan: (value: any) => void,
  handleDelete: (value: any) => void,
): ColumnsType<any> => [
  {
    title: "Tanggal",
    dataIndex: "tanggal_pengajuan",
    key: "tanggal_pengajuan",
    width: 240,
    render: (tanggal_pengajuan) =>
      moment(tanggal_pengajuan).format("dddd,DD MMM YYYY HH:mm:ss"),
  },
  {
    title: "Batch",
    key: "batch",
    width: 100,
    dataIndex: "batch",
    render: (batch) => {
      let namaBatch = listBatch.find((item) => item.kode === batch) || null;
      return namaBatch?.nama;
    },
  },
  {
    title: "Tahapan",
    key: "tahapan",
    width: 100,
    dataIndex: "tahapan",
    render: (tahapan) => `Tahap ${tahapan}`,
  },
  columnJenjang,
  {
    title: "Total Anggaran",
    key: "total_anggaran",
    width: 160,
    dataIndex: "total_anggaran",
    render: (total_anggaran) => (
      <div className="text-right">{formatCurr(total_anggaran)}</div>
    ),
  },
  {
    title: "Lembaga",
    key: "jumlah_lembaga",
    dataIndex: "jumlah_lembaga",
  },

  {
    title: "Periode",
    key: "periode",
    children: [
      {
        title: "Mulai",
        dataIndex: "tanggal_mulai_verifikasi",
        width: 200,
        key: "tanggal_mulai_verifikasi",
        render: (tanggal_mulai_verifikasi) =>
          moment(tanggal_mulai_verifikasi).format("DD MMMM YYYY"),
      },
      {
        title: "Akhir",
        dataIndex: "tanggal_akhir_verifikasi",
        width: 200,
        key: "tanggal_akhir_verifikasi",
        render: (tanggal_akhir_verifikasi) =>
          moment(tanggal_akhir_verifikasi).format("DD MMMM YYYY"),
      },
    ],
  },
  {
    title: "Aksi",
    key: "aksi",
    width: 120,
    fixed: "right",
    render: (record) => {
      return (
        <Space>
          <ButtonTableDetail
            tooltips="Shortlist"
            onClick={() =>
              route.push({
                pathname: `/pencairan/pengajuan/sortlist`,
                state: {
                  ...dataState,
                  ...record,
                },
              })
            }
            // onClick={() => handlePriviewShortlist(record)}
          />
          {isJenjangValid(record?.jenjang) && (
            <>
              <ButtonTableApproval
                tooltips={
                  dataState?.activeTabKey === "pengajuan"
                    ? "Pencairan"
                    : "Dicairkan"
                }
                onClick={() => handlePencairan(record)}
              />
              <ButtonTableDelete
                onClick={() => {
                  Modal.confirm({
                    title: "Perhatian",
                    content: "Yakin Hapus Data?",
                    centered: true,
                    wrapClassName: "erkam-custom-modal",
                    onOk() {
                      return handleDelete(record);
                    },
                    okText: "Hapus",
                    cancelText: "Batal",
                    okType: "danger",
                  });
                }}
              />
            </>
          )}
        </Space>
      );
    },
  },
];

export const columnsPencairan = (
  route: any,
  tmpState: any,
  handleDelete: (values: any) => void,
): ColumnsType<any> => [
  {
    title: "Tanggal Penyaluran",
    dataIndex: "tanggal_penyaluran",
    width: 240,
    key: "tanggal_penyaluran",
    render: (tanggal_penyaluran) =>
      moment(tanggal_penyaluran).format("dddd,DD MMM YYYY HH:mm:ss"),
  },
  {
    title: "Tanggal Pengajuan",
    dataIndex: "tanggal_pengajuan",
    width: 240,
    key: "tanggal_pengajuan",
    render: (tanggal_pengajuan) =>
      moment(tanggal_pengajuan).format("dddd,DD MMM YYYY HH:mm:ss"),
  },
  {
    title: "Batch",
    key: "batch",
    width: 100,
    dataIndex: "batch",
    render: (batch) => {
      let namaBatch = listBatch.find((item) => item.kode === batch) || null;
      return namaBatch?.nama || "";
    },
  },
  {
    title: "Tahapan",
    key: "tahapan",
    width: 100,
    dataIndex: "tahapan",
    render: (tahapan) => `Tahap ${tahapan}`,
  },
  columnJenjang,
  {
    title: "Total Anggaran",
    key: "total_anggaran",
    width: 160,
    dataIndex: "total_anggaran",
    render: (total_anggaran) => (
      <div className="text-right">{formatCurr(total_anggaran)}</div>
    ),
  },
  {
    title: "Lembaga",
    key: "jumlah_lembaga",
    dataIndex: "jumlah_lembaga",
  },

  {
    title: "Periode",
    key: "periode",
    children: [
      {
        title: "Mulai",
        dataIndex: "tanggal_mulai_verifikasi",
        key: "tanggal_mulai_verifikasi",
        width: 200,
        render: (tanggal_mulai_verifikasi) =>
          moment(tanggal_mulai_verifikasi).format("DD MMMM YYYY"),
      },
      {
        title: "Akhir",
        dataIndex: "tanggal_akhir_verifikasi",
        key: "tanggal_akhir_verifikasi",
        width: 200,
        render: (tanggal_akhir_verifikasi) =>
          moment(tanggal_akhir_verifikasi).format("DD MMMM YYYY"),
      },
    ],
  },
  {
    title: "Aksi",
    key: "aksi",
    width: 100,
    fixed: "right",
    render: (record) => {
      return (
        <Space>
          <ButtonTableDetail
            onClick={() =>
              route.push({
                pathname: `/pencairan/pengajuan/sortlist`,
                state: {
                  ...tmpState,
                  ...record,
                },
              })
            }
            tooltips="Shortlist"
          />
          {isJenjangValid(record?.jenjang) && (
            <ButtonTableDelete
              onClick={() => {
                Modal.confirm({
                  title: "Perhatian",
                  content: "Yakin Hapus Data?",
                  centered: true,
                  wrapClassName: "erkam-custom-modal",
                  onOk() {
                    return handleDelete(record);
                  },
                  okText: "Hapus",
                  cancelText: "Batal",
                  okType: "danger",
                });
              }}
            />
          )}
        </Space>
      );
    },
  },
];

export const columnsSortlist = (provinsi: any, kabkota: any) => [
  {
    title: "NSM",
    key: "nsm",
    dataIndex: "nsm",
  },
  {
    title: "Madrasah",
    dataIndex: "nama_madrasah",
    key: "nama_madrasah",
  },
  {
    title: "Jenjang",
    dataIndex: "jenjang",
    key: "jenjang",
    render: (jenjang) => <div className="uppercase">{jenjang}</div>,
  },
  {
    title: "Provinsi",
    dataIndex: "kode_provinsi",
    key: "kode_provinsi",
    render: (kode_provinsi) => {
      return provinsi.find((item) => item.kode === kode_provinsi)?.nama || "";
    },
  },
  {
    title: "Kabkota",
    dataIndex: "kode_kabkota",
    key: "kode_kabkota",
    render: (kode_kabkota) => {
      return kabkota.find((item) => item.kode === kode_kabkota)?.nama || "";
    },
  },
  {
    title: "Alokasi Anggaran",
    key: "Nominal",
    children: [
      {
        title: "Tahap 1",
        dataIndex: "tahap1",
        key: "tahap1",
        render: (tahap1) => (
          <div className="text-right">{formatCurr(tahap1)}</div>
        ),
      },
      {
        title: "Tahap 2",
        key: "tahap2",
        dataIndex: "tahap2",
        render: (tahap2) => (
          <div className="text-right">{formatCurr(tahap2)}</div>
        ),
      },
      {
        title: "Triwulan 1",
        key: "triwulan1",
        dataIndex: "triwulan1",
        render: (triwulan1) => (
          <div className="text-right">{formatCurr(triwulan1)}</div>
        ),
      },
      {
        title: "Triwulan 2",
        key: "triwulan2",
        dataIndex: "triwulan2",
        render: (triwulan2) => (
          <div className="text-right">{formatCurr(triwulan2)}</div>
        ),
      },
      {
        title: "Triwulan 3",
        key: "triwulan3",
        dataIndex: "triwulan3",
        render: (triwulan3) => (
          <div className="text-right">{formatCurr(triwulan3)}</div>
        ),
      },
      {
        title: "Triwulan 4",
        key: "triwulan4",
        dataIndex: "triwulan4",
        render: (triwulan4) => (
          <div className="text-right">{formatCurr(triwulan4)}</div>
        ),
      },
      {
        title: "Total",
        key: "total",
        // dataIndex: "total",
        render: (record) => {
          let total =
            record?.tahap1 +
            record?.tahap2 +
            record?.triwulan1 +
            record?.triwulan2 +
            record?.triwulan3 +
            record?.triwulan4;
          return <div className="text-right">{formatCurr(total)}</div>;
        },
      },
    ],
  },
  {
    title: "Tahapan",
    key: "tahapan",
    dataIndex: "tahapan",
    render: (tahapan) => `Tahap ${tahapan}`,
  },
  {
    title: "Tanggal Verifikasi",
    key: "tanggal_verifikasi",
    dataIndex: "tanggal_verifikasi",
    render: (tanggal_verifikasi) =>
      moment(tanggal_verifikasi).format("dddd,DD MMM YYYY HH:mm:ss"),
  },
  {
    title: "Rekening Madrasah",
    key: "rekening",
    children: [
      {
        title: "Nama BANK",
        dataIndex: "nama_bank",
        key: "nama_bank",
      },
      {
        title: "No Rekening",
        key: "nomor_rekening",
        dataIndex: "nomor_rekening",
      },
      {
        title: "Nama Pemilik",
        key: "nama_pemilik_rekening",
        dataIndex: "nama_pemilik_rekening",
      },
      {
        title: "Cabang",
        key: "cabang",
        dataIndex: "cabang",
      },
    ],
  },
];
